import { render, staticRenderFns } from "./Credit.vue?vue&type=template&id=9cb99652&scoped=true&"
import script from "./Credit.vue?vue&type=script&lang=ts&"
export * from "./Credit.vue?vue&type=script&lang=ts&"
import style0 from "./Credit.vue?vue&type=style&index=0&id=9cb99652&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../boss_taobao/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cb99652",
  null
  
)

export default component.exports